(() => {
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const updatePlayback = (video) => {
    if (!mobileQuery.matches || reducedMotionQuery.matches) {
      video.pause();
      return;
    }

    video.play().catch(() => {
      // The poster remains visible if the browser blocks autoplay.
    });
  };

  const refreshVideos = () => {
    document.querySelectorAll('[data-rielli-mobile-hero-video]').forEach(updatePlayback);
  };
  refreshVideos();
  mobileQuery.addEventListener('change', refreshVideos);
  reducedMotionQuery.addEventListener('change', refreshVideos);
  document.addEventListener('shopify:section:load', refreshVideos);
})();
